const func = $target => {
    let $radioInput = $target.find('.radioInput'),
        $dsdUpperLowerText =  $target.find('.dsdUpperLower');

    $dsdUpperLowerText.find('.text-muted').addClass('d-none')

    $radioInput.click(function (){
        var $value = $(this).val(),
            $input = $dsdUpperLowerText.find('textarea');

        if ($value == 'other'){
            $dsdUpperLowerText.removeClass('d-none');
            $input.attr('required',true).attr('name','dsdUpperLowerOtherConsiderations')
            $radioInput.attr('name','others')
        }else {
            $radioInput.attr('name','dsdUpperLowerCaseConsiderations')
            $dsdUpperLowerText.addClass('d-none');
            $input.attr('required',false).attr('name','')
        }
    })
}

export default func;